export const environment = {
  production: false,
  isMockEnabled: false, // You have to switch this, when your real back-end is done
  baymax_backend_url: "https://baymax.uexglobal.com/uex/v1/",
  baymax_backend_root_url: "https://baymax.uexglobal.com/",
  baymax_backend_back_office_url: "https://baymax.uexglobal.com/backoffice/v1/",
  baymax_client_id: "7R5luyIUPxuIFKdOOTTq8IF073KxJqWAdNrRUdPV",
  baymax_client_secret:
    "tvWj71UPNvNFM3q0BRem2ZWgkGIJdmuodtWP9jkjooXlJJT8S9SJ9xVRKVbjjrUWxHzt90Fl2QYbef4MtEIRIi8o5j7co9kCm1XQ5pT5p04S31kn9ve9zjbJnMGMzEIi",
  baymax_grant_type: "password",
  apiVersion: "BACKOFFICE_5_2",
  originSite: "uex-backoffice-prod"
};
